<template>
  <base-content>
    <template v-slot:top>
      <base-banner>Attitude to Risk</base-banner>
      <appropriateness-steps :step="3" />
    </template>
    <div v-if="loaded">
      <form @submit.prevent="submit">
        <p class="font-weight-bold mb-4">
          Please tell us what type of investor you are? Please consider and select carefully as the responses
          may impact on whether we can accept you as an investor on the platform.
        </p>
        <base-card>
          <template v-slot:header>
            <base-card-heading>I am a low risk investor</base-card-heading>
            <button-option v-model="risk.low" @input="setRisk('Low')" />
          </template>
          <p>
            This category is usually appropriate to those that do not like to take risk with their investments.
            They would prefer to keep their money in the bank, but would be willing to invest in other types of
            investments if they were likely to be better for the longer term and of a low risk nature.
          </p>
        </base-card>
        <base-card>
          <template v-slot:header>
            <base-card-heading>I am a medium risk investor</base-card-heading>
            <button-option v-model="risk.medium" @input="setRisk('Medium')" />
          </template>
          <p>
            This category is usually appropriate to those that understand the consequences of taking investment
            risk in order to be able to meet their long-term goals. They are likely to be willing to take risk
            with at least part of their available assets.
          </p>
          <ul>
            <li>You are happy to put a significant proportion of your money in shares or other longer-term investment types.</li>
            <li>You are equally concerned about limiting your losses as you are about achieving returns on your investment.  </li>
          </ul>
        </base-card>
        <base-card>
          <template v-slot:header>
            <base-card-heading>I am a high risk investor</base-card-heading>
            <button-option v-model="risk.high" @input="setRisk('High')" />
          </template>
          <p>
            This category is usually appropriate to those that are happy to take on significant investment risk.
            They are willing to take a higher risk with a significant proportion of their available assets.
            High-risk investors will usually be experienced investors, who have used a range of investment products in the past,
            and who may take an   active approach to managing their investments. If you’re prepared to take high risk,
            it’s likely that you’re an experienced and knowledgeable investor, whose primary aim is to achieve the highest
            possible returns on your money, while accepting that this means taking substantial risks.
          </p>
        </base-card>
        <base-card>
          <p>
            Have you read the full risk warning which can be found <a href="https://saxontrust.com/risk-warning/">HERE</a> and fully understand that, as with all investing,
            your capital and any returns offered may be at risk if you invest and that all projected investment terms are linked to underlying
            loan performance and loans may be repaid early or later than originally anticipated?
          </p>
          <div class="text-center">
            <button-options v-model="read" name="understandRisk" :options="options" />
          </div>
        </base-card>
        <div class="row">
          <div class="col-12 col-sm-6">
            <base-button exact :to="{ name: 'dashboard' }">Come back later</base-button>
          </div>
          <div class="col-12 col-sm-6 text-right">
            <base-button icon-right="arrow-right" primary submit :loading="saving">
              Next section
            </base-button>
          </div>
        </div>
      </form>
    </div>
    <div v-else>
      <base-loader />
    </div>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AppropriatenessSteps from '@/components/AppropriatenessSteps.vue'
import ButtonOption from '@/components/ButtonOption.vue'
import ButtonOptions from '@/components/ButtonOptions.vue'

export default {
  components: {
    AppropriatenessSteps,
    ButtonOption,
    ButtonOptions
  },

  data: () => ({
    loaded: false,
    options: {
      false: 'No',
      true: 'Yes'
    },
    payload: {},
    read: '',
    risk: {
      low: false,
      medium: false,
      high: false
    },
    saving: false
  }),

  mounted () {
    this.payload = this.$_.cloneDeep(this.$auth.user.appropriateness)

    this.setRisk(this.payload.risk)

    this.loaded = true
  },

  computed: {
    ...mapState({
      appropriateness: store => store.core.userAppropriateness.entity
    })
  },

  methods: {
    setRisk (risk) {
      this.payload.risk = risk

      Object.keys(this.risk).forEach(k => {
        this.risk[k] = risk.toLowerCase() === k
      })
    },

    async submit () {
      if (this.read !== 'true') {
        this.$dialog.alert('You must confirm that you have read the full risk warning before you can continue.')
        return
      }

      this.saving = true

      await this.$store.dispatch('core/user-appropriateness/update', this.payload)

      this.$store.commit('core/auth/appropriateness', this.appropriateness)

      this.$router.push({ name: 'appropriateness.wealth' })
    }
  }
}
</script>
